import React, { useState } from 'react';
import { useReviewNavigate, useAppointmentDetails } from '../organisms/ReviewWrapper';
import PoweredByApruv from '../common/PoweredByApruv';
import checkCircle from '../../assets/images/check-circle.svg';
import './ReviewDone.css';

interface ReviewDoneProps {
  isOldReview?: boolean;
  onStepChange?: (step: string) => void;
}

const ReviewDone: React.FC<ReviewDoneProps> = () => {
  const navigate = useReviewNavigate();
  const appointmentDetails = useAppointmentDetails(); // Get from context
  const [loading, setLoading] = useState(false);

  const handleReviewGoogle = async () => {
    if (!appointmentDetails) return;
    if (appointmentDetails.appointment_details.GoogleLink) {
      window.location.href = appointmentDetails.appointment_details.GoogleLink;
    }
  };

  const handleContactUs = () => {
    if (!appointmentDetails) return;
    const phoneNumber = appointmentDetails.appointment_details.CompanyPhone;
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    }
  };

  const handleDone = () => {
    navigate('/');
  };

  if (!appointmentDetails) {
    return (
      <div className="review-done-container">
        <div className="review-done-loading">Loading...</div>
        <PoweredByApruv />
      </div>
    );
  }

  return (
    <div className="review-done-container">
      <div className="review-done-content" style={{ justifyContent: 'center', alignItems: 'center' }}>
        {/* Company Logo */}
        {appointmentDetails.appointment_details.CompanyImageUrl && (
          <div className="review-done-company-logo">
            <img src={checkCircle}/>
          </div>
        )}
        {/* Thank You Message */}
        <h1 className="review-done-title" style={{ marginBottom: 8 }}>You're all done</h1>
        {/* Company Name */}
        <p className="review-done-subtitle" style={{ marginBottom: 32 }}>
        Your review has successfully been sent to the area manager at {appointmentDetails.appointment_details.CompanyName}
        </p>
        {/* Primary Action Button */}
        {appointmentDetails.appointment_details.CompanyPhone && (
          <button
            onClick={handleContactUs}
            className="contact-us-button primary"
            style={{ width: '100%', maxWidth: 320 }}
          >
            Contact Us
          </button>
        )}
        {appointmentDetails.appointment_details.GoogleLink && (
          <button
            onClick={handleReviewGoogle}
            disabled={loading}
            className="review-done-button primary"
            style={{ width: '100%', maxWidth: 320 }}
          >
            {loading ? 'Loading...' : 'Leave a Review'}
          </button>
        )}
        <PoweredByApruv sx={{ mt: 1 }} />
      </div>
    </div>
  );
};

export default ReviewDone;
